// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E9O_","col":"styles_col__10--q"};